<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="6" xl="4" class="mb-5">
            <b-button variant="primary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.vop_provider.add_vop_provider')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <!-- Filtre Name -->
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <label class="filter-item-title" for="filter-name">{{ $t('common.vop_provider.name') }}</label>
            <span class="filter-item-content">
              <input v-model.trim="NameVopProvider"
                id="filter-name"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': NameVopProvider}"
                :placeholder="$t('common.vop_provider.name')"
                style="width: 100%">
            </span>
          </b-col>
        </b-row>

        <b-row class="justify-content-end" v-if="displayFilter">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="mr-3" size="sm"
                      @click="clearFilterFields" :disabled="activateSpinner">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="btn" size="sm"
                      @click="onRefresh">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col cols="12">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsVopProvider.length > 0"
                :items="listItemsVopProvider"
                :fields="fields"
                class="table-striped"
                hover
                :selectable="listItemsVopProvider.length > 0"
                :empty-text="$t('common.security.no_result')"
                style="margin-bottom:0"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                @row-selected="onRowClicked"
                :key="refreshKey">
                <template #cell(NameVopProvider)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(edit)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdVopProvider)">
                    <i class="fa-regular fa-pencil"></i>
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdVopProvider)">
                    <i class="fa-regular fa-trash"></i>
                  </span>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import backButton from "@/components/common/backButton.vue"

export default {
  name: "VopProviderPage",
  components: {
    'back-button': backButton,
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterConditions: {},
      listItemsVopProvider: [],
      listTitle: "",
      NameVopProvider: '',
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      returnUrl: '',
      sortBy: '',
      sortDir: false
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.role = this.$route.query.role
    if (this.role === '1') {
      this.returnUrl = '/routing/configlist/1/0/rvm'
    } else if (this.role === '0') {
      this.returnUrl = '/routing/configlist/0/0/rvm'
    } else {
      this.returnUrl = '/entitiessettings/rvm/BICRVM'
    }

    this.listTitle = this.$i18n.t("common.vop_provider.vop_provider")
    this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getVopProvider(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.getVopProvider()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'NameVopProvider',
        label: this.$t('common.vop_provider.name'),
        class: 'text-center',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), class: 'text-center', sortable: false })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), class: 'text-center', sortable: false })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/vopProvider/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.vop_provider.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { IdVopProvider: id }
              that.$engine.vopProvider.deleteVopProvider(params)
              .then(resp => {
                that.listItemsVopProvider = that.listItemsVopProvider.filter(item => item.IdVopProvider !== id)
                that.$f7.modal({
                  title: that.$t('common.vop_provider.vop_provider_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/vopProvider/' })
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "Deletion Error") {
                      that.okMessageBox(that.$t('common.vop_provider.unable_del'))
                    }
                  })
                } else {
                    errorMessageAlert(e, that, that.$i18n)
                    that.okMessageBox(that.$t('common.vop_provider.vop_provider_delete_error'))
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/vopProvider/edit/' + id })
    },
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getVopProvider()
    },
    clearFilterFields() {
      this.NameVopProvider = ''
      // this.applyFilter()
    },
    getVopProvider(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        NameVopProvider: this.NameVopProvider,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.vopProvider.getVopProvider(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.VopProvider.length

        let vopProviderList = {}

        vopProviderList = resp.data.VopProvider

        that.updateVopProvider(vopProviderList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getVopProvider()
    },
    onRowClicked(item) {
      if (item[0] && item[0].IdVopProvider) {
        loadPage(this, { url: '/vopProvider/details/' + item[0].IdVopProvider })
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'NameVopProvider'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateVopProvider(vopProviderList) {
      this.listItemsVopProvider = vopProviderList
    }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 70px;
  }
}
</style>
